import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

const Container = styled.div`
    position: fixed;
    left: 0;
    width: 100%;
    top: ${({show}) => show ? '0' : '-6em'};
    overflow: hidden;
    height: 6em;
    z-index: 2;
    transition: 0.3s top;
`

Container.propTypes = {
    show: PropTypes.bool,
}

class ScrollObserver extends React.Component {
    static propTypes = {
        observableElement: PropTypes.any,
        children: PropTypes.element,
    }

    static defaultProps = {
        observableElement: null,
    }

    state = {
        show: false,
    }

    handleIntersection (entries) {
        const show = entries[0].boundingClientRect.y < 0 && !entries[0].isIntersecting
        this.setState({show})
    }
    handleIntersection = this.handleIntersection.bind(this)

    componentDidMount () {
        this.observer = new window.IntersectionObserver(this.handleIntersection)
    }

    componentDidUpdate ({ observableElement }) {
        const observable = this.props.observableElement
        if (observable && observableElement !== observable) {
            this.observer.disconnect()
            this.observer.observe(observable)
        }
    }

    componentWillUnmount () {
        this.observer.disconnect()
    }

    render () {
        return (
            <Container show={this.state.show}>
                {this.props.children}
            </Container>
        )
    }
}

export default ScrollObserver
